import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { Endpoints } from "../../Global/Endpoints";
import ErrorModal from "../Security/ErrorModal";


import loginImage01 from "../../assets/images/registration/registration-steps-image-01.jpg";
import loginImage02 from "../../assets/images/registration/registration-steps-image-03.jpg";
import loginImage03 from "../../assets/images/registration/registration-steps-image-04.jpg";

const FourthTrimesterPreviewDeliveryDetails = () => {
  const userInfo = useSelector((state) => state.userData);
  const token = localStorage.getItem('AccessToken');

  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  //const {step = 4, totalSteps = 4 } = location.state || {};

  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";



  // Destructure the passed state
  const { commonData, babies,isMetric,deliveryDate } = location.state || {};

  const handleEdit = () => {
    // Navigate back to the delivery details page for editing
    navigate("/fourth-trimester-delivery-details", {
      state: {
        commonData,
        babies,
        isMetric,
      },
    });;
  };

  useEffect(() => {
    const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
    if (myCarousel) {
        new window.bootstrap.Carousel(myCarousel, {
          interval: 5000, // Set interval in milliseconds
        });
      }
  }, []);
  const handleSubmit = async () => {
    try {
      // Prepare the parameters to send in the request
      const params = {
        DeliveryDate: deliveryDate,
        EmailID: userInfo.userData.EmailID,
        BabyCount: babies.length,
        DoYouHaveBaby: "Yes",
        DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
        PregnencyStatus:"",
        Address:commonData.Address,
        WINOnesieGift: commonData.WINOnesieGift,
        BabyInfo: babies.map((baby) => ({
          BabyLength: baby.length,
          BabyLengthType:commonData.LengthType,
          BabyWeight: baby.weight,
          BabyWeightType:commonData.WeightType,
          HospitalName: commonData.hospitalName,
          Obstetrician: commonData.Obstetrician,
          DeliveryDetails: commonData.deliveryType,
          Pediatrician: commonData.Pediatrician,
          BabyName: baby.name,
          BabyNicuCare: baby.nicu
        })),
      };
      // Make the API call
      const response = await axios.post(
        Endpoints.SaveFourthTrimisterCheckin,
        { _Params: JSON.stringify(params) },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Connection": "close",
            "Accept": "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      // Check if the response indicates success
      if (response.data === "Details saved successfully") {
        setModalMessage("Data Saved successfully.");
        setShowModal(true);
      } else {
        console.error("Error status:", response.data);
        // Revert the change in the UI if API fails
        setModalMessage(response.data);
        setShowModal(true);
        console.log("babyres",response)
      }
    } catch (error) {
      console.error("Error:", error);
      // Revert the change in case of an error
    }
  };
  const handleModalClose = () => {
    setShowModal(false);
    if (modalMessage === "Data Saved successfully.") {
      navigate("/home");
    }
      
  };

  return (
    <>
    <div className="registration-block-main">
      {/* Carousel Section */}
      <div className="registration-image-wrapper">
        <div
          id="carouselExampleSlidesOnly"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner">
            <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
              <img src={loginImage01} alt="" className="registration-image" />
            </div>
            <div className="carousel-item login-carousel-item" data-bs-interval="5000">
              <img src={loginImage02} alt="" className="registration-image" />
            </div>
            <div className="carousel-item login-carousel-item" data-bs-interval="5000">
              <img src={loginImage03} alt="" className="registration-image" />
            </div>
          </div>
        </div>
      </div>

      {/* Form Section */}
      <div className="registration-form-main">
        <div className="registration-form">
          {/* Heading and Intro */}
          <h2 className="page-heading-bold mb-3">Thank you for sharing!</h2>
          <p>Please review to ensure the information we captured is correct.</p>

          {/* Delivery Info */}
          {/* <div className="row mb-2">
            <div className="col-6">Name (Optional)</div>
            <div className="col-6"><strong>{commonData?.hospitalName || "Not provided"}</strong></div>
          </div>
          <div className="row mb-2">
            <div className="col-6">Delivery Details</div>
            <div className="col-6"><strong>{commonData?.deliveryType || "Not provided"}</strong></div>
          </div>
          <div className="row mb-2">
            <div className="col-6">Obstetrician</div>
            <div className="col-6"><strong>{commonData?.Obstetrician || "Not provided"}</strong></div>
          </div>
          <div className="row mb-4">
            <div className="col-6">Pediatrician</div>
            <div className="col-6"><strong>{commonData?.Pediatrician || "Not provided"}</strong></div>
          </div> */}

          {/* Display babies details */}
          {babies.length > 0 ? (
            babies.map((baby, index) => (
              <div key={index} className="mb-4">
                <h4 className="page-heading-bold-primary-20">BABY {index + 1}</h4>
                <div className="row mb-2">
                  <div className="col-6">Name</div>
                  <div className="col-6"><strong>{baby.name || "Not provided"}</strong></div>
                </div>
                <div className="row mb-2">
                  <div className="col-6">Weight</div>
                  <div className="col-6"><strong>{(baby.weight || "Not provided") + " " + (commonData.WeightType || "")}</strong></div>
                </div>
                <div className="row mb-2">
                  <div className="col-6">Length</div>
                  <div className="col-6">
                    <strong>
                      {(baby.length || "Not provided") + " " + (commonData.LengthType === "inches" ? "in" : commonData.LengthType || "")}
                    </strong>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-6">Delivery Details</div>
                  <div className="col-6"><strong>{commonData?.deliveryType || "Not provided"}</strong></div>
                </div>
                <div className="row mb-2">
                  <div className="col-6">Hospital</div>
                  <div className="col-6"><strong>{commonData?.hospitalName || "Not provided"}</strong></div>
                </div>
                <div className="row mb-2">
                  <div className="col-6">Obstetrician</div>
                  <div className="col-6"><strong>{commonData?.Obstetrician || "Not provided"}</strong></div>
                </div>
                <div className="row mb-2">
                  <div className="col-6">NICU</div>
                  <div className="col-6"><strong>{baby.nicu === "Y" ? "Yes" : baby.nicu === "N" ? "No" : "Not provided"}</strong></div>
                </div>
              </div>
            ))
          ) : (
            <div>No babies data available.</div>
          )}

          {/* Action Buttons */}
          {isHighmarkPortal ? (
    //Highmark-specific pagination format
    <div className="pagination-wrapper mt-5">
      <button className="previous-btn" onClick={handleEdit}></button>
      {/* <span className="me-3">{`${step} of ${totalSteps}`}</span> */}
      <span className="me-3">3 of 3</span>
      <button className="next-btn" onClick={handleSubmit}></button>
    </div>
  ) : (
    //Default buttons for non-SSO users
    <>
      <div className="mt-3 mb-5 d-flex">
        <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={handleEdit}>Edit</button>
        <button className="win-btn-primary mobile-view me-3 mb-2 mb-md-0" onClick={handleSubmit}>Submit</button>
      </div>
    </>
  )}
          
        </div>
      </div>
    </div>
    <ErrorModal show={showModal} message={modalMessage} onClose={handleModalClose} closeButton={true}  />
  </>
  );
};

export default FourthTrimesterPreviewDeliveryDetails;